import { AbstractModel } from "@uzurv/core";
import { autoserialize, inheritSerialization } from "cerialize";

@inheritSerialization(AbstractModel)
export class IgnoredRideRequest extends AbstractModel {
  @autoserialize
	rideRequestId: number;

  @autoserialize
	providerId: number;

  @autoserialize
	createdByUserId: number;

  @autoserialize
	active: boolean;

  static OnSerialized(instance: IgnoredRideRequest, json: any): void {
    super.OnSerialized(instance, json);
  }

  static OnDeserialized(instance: IgnoredRideRequest, json: any): void {
     super.OnDeserialized(instance, json);
  }
}
